import { Component } from '@angular/core';
import { ApiService } from '../services/api/api.service';

interface Links {
  address : string;
  icon?    : string;
  title   : string;
};

@Component({
  selector: 'app-auswertung',
  templateUrl: './auswertung.component.html',
  styleUrls: ['./auswertung.component.css']
})
export class AuswertungComponent {  
    
  topLinks : Array<Links> = [
    {
      address:  "/auswertung/uebersicht",
      title:    "Übersicht",
    },
    {
      address:  "/auswertung/krankheit",
      title:    "Krankheit",
    },
    {
      address:  "/auswertung/em_bu",
      title:    "EM / BU",
    },
    {
      address:  "/auswertung/unfall",
      title:    "Unfall",
    },
    {
      address:  "/auswertung/alter",
      title:    "Alter",
    },
    {
      address:  "/auswertung/pflege",
      title:    "Pflege",
    },
  ]
  
  public name : string;
  
  constructor(private api: ApiService) {
    this.api.getName().then((values) => {
      this.name = values.firstName + ' ' + values.lastName;
    }, (error) => {
      alert( error );
    });  
  }
    
}



// WEBPACK FOOTER //
// ./src/app/auswertung/auswertung.component.ts